// import Vue from 'vue'
// import VueRouter from 'vue-router'


// Vue.use(VueRouter)

// const routes = [
 
//   {
//     path: '/',
//     name: 'logo',
//    component: () => import(/* webpackChunkName: "about" */ '../views/LogoView.vue')
//   },
//   // 设备管理
//   {
//     path: '/device',
//     // name: 'device',
//     component: () => import(/* webpackChunkName: "about" */ '../views/DeviceView.vue')
   
//   },
//   // 排菜
//    {
//     path: '/planning',
//     name: 'planning',
//     component: () => import(/* webpackChunkName: "about" */ '../views/PlanningView.vue')
   
//   },
//    // 采购管理
//    {
//     path: '/procurement',
//     name: 'procurement',
  
//     component: () => import(/* webpackChunkName: "about" */ '../views/ProcurementView.vue')
//   },
//   // 农残
//   {
//     path: '/pesticide',
//     name: 'pesticide',
//     component: () => import('../views/PesticideView.vue')
   
//   },
//   // 留样柜
//  {
//     path: '/Sample',
//     name: 'Sample',
//     component: () => import('../views/SampleView.vue')
   
//   },
// // 消毒柜
//   {
//     path: '/xiaodugui',
//     name: 'xiaodugui',
//     component: () => import('../views/CabinetView.vue')
   
//   },
//   // 环境检测

//    {
//     path: '/detection',
//     name: 'detection',
//     component: () => import('../views/DetectionView.vue')
   
//   },
//   // 晨检仪
//    {
//     path: '/morningCheck',
//     name: 'morningCheck',
//     component: () => import('../views/MorningCheck.vue')
   
//   },
// //  功能间管理
// {
//   path: '/function',
//     name: 'function',
//     component: () => import('../views/FunctionView.vue')
// },
// //  首页
// {
//   path: '/index',
//   name: 'index',

//   component: () => import(/* webpackChunkName: "about" */ '../views/IndexView.vue')
// },
// // 公告展示
// {
//   path: '/organization',
//   name: 'organization',

//   component: () => import(/* webpackChunkName: "about" */ '../views/OrganizationView.vue')
// },
// // 轮播图
// {
//   path: '/warehouse',
//   name: 'warehouse',

//   component: () => import(/* webpackChunkName: "about" */ '../views/WarehouseView.vue')
// },
// {
//   path: '/warehouse1',
//   name: 'warehouse1',

//   component: () => import(/* webpackChunkName: "about" */ '../views/WarehouseView1.vue')
// },
// {
//   path: '/warehouse2',
//   name: 'warehouse2',

//   component: () => import(/* webpackChunkName: "about" */ '../views/WarehouseView2.vue')
// },


// {
//   path: '/cooking',
//   name: 'cooking',
//   component: () => import('../views/CookingView.vue')
 
// },
// {
//   path: '/manage',
//   name: 'manage',
//   component: () => import('../views/ManageView.vue')
 
// },

// // 4D物料中心
// {
//   path: '/supplier',
//   name: 'supplier',

//   component: () => import(/* webpackChunkName: "about" */ '../views/SupplierView.vue')
// },
// {
//   path: '/order',
//   name: 'order',
//   component: () => import('../views/OrderView.vue')
 
// },

// // 所需食材

// {
//   path: '/requirement',
//   name: 'requirement',

//   component: () => import(/* webpackChunkName: "about" */ '../views/RequirementView.vue')
// },
// {
//   path: '/apprecord',
//   name: 'apprecord',
//   component: () => import('../views/ApprecordView.vue')
 
// },
// // 报价
// {
//   path: '/quotation',
//   name: 'quotation',
//   component: () => import(/* webpackChunkName: "about" */ '../views/QuotationView.vue')
// },
// // 菜品管理
// {
//   path: '/dish',
//   name: 'dish',

//   component: () => import(/* webpackChunkName: "about" */ '../views/DishView.vue')

// },
// {
//   path: '/cover',
//   name: 'cover',

//   component: () => import(/* webpackChunkName: "about" */ '../views/CoverView.vue')

// },
// // 培训中心详情图片
// {
//   path: '/analysis',
//   name: 'analysis',
//   component: () => import('../views/AnalysisView.vue')
 
// },
// {
//   path: '/app',
//   name: 'app',
//   component: () => import('../views/AppView.vue')
 
// },
// // 菜谱
// {
//   path: '/menu',
//   name: 'menu',
//   component: () => import('../views/MenuView.vue')
 
// },
// // 案例详情
// {
//   path: '/promotion',
//   name: 'promotion',
//   component: () => import('../views/PromotionView.vue')
 
// },
// // 人员管理
// {
//   path: '/personnel',
//   name: 'personnel',

//   component: () => import(/* webpackChunkName: "about" */ '../views/PersonnelView.vue')
// },
// // 客户管理
// {
//   path: '/customer',
//   name: 'customer',

//   component: () => import(/* webpackChunkName: "about" */ '../views/CustomerView.vue')
// },
// // 仓库模版
// {
//   path: '/terminal',
//   name: 'terminal',

//   component: () => import(/* webpackChunkName: "about" */ '../views/TerminalView.vue')
// },
// // 半成品
// {
//   path: '/product',
//   name: 'product',

//   component: () => import(/* webpackChunkName: "about" */ '../views/ProductView.vue')
// },
// // 出入库记录
// {
//   path: '/record',
//   name: 'record',

//   component: () => import(/* webpackChunkName: "about" */ '../views/RecordView.vue')
// },
// // 下单
// {
//   path: '/customerorder',
//   name: 'customerorder',

//   component: () => import(/* webpackChunkName: "about" */ '../views/CustomerOrder.vue')
// },
// // 食材模版

// {
//   path: '/ingredients',
//   name: 'ingredients',

//   component: () => import(/* webpackChunkName: "about" */ '../views/IngredientsView.vue')
// },
// // 功能间设备

// {
//   path: '/functionaldata',
//   name: 'functionaldata',

//   component: () => import(/* webpackChunkName: "about" */ '../views/FunctionalData.vue')
// },
// // 角色
// {
//   path: '/role',
//   name: 'role',

//   component: () => import(/* webpackChunkName: "about" */ '../views/RoleView.vue')
// },
// ]

// const router = new VueRouter({
//   // mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })

// export default router
import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import componentMap from './componentMap'
import LogoView from '../views/LogoView.vue'
import store from '@/store' // 引入Vuex实例

Vue.use(VueRouter)

// 基础路由：仅保留登录页
const baseRoutes = [
  {
    path: '/',
    name: 'logo',
    component: LogoView
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes: baseRoutes
})

// 1. 扁平化路由数组（保留原逻辑）
function flattenRoutes(routes) {
  const result = [];
  const processRoute = (route) => {
    result.push({ ...route });
    if (route.children && route.children.length > 0) {
      route.children.forEach(child => processRoute(child));
    }
  };
  routes.forEach(route => processRoute(route));
  return result;
}

// 2. 转换后端路由为Vue Router格式（保留原逻辑）
function convertRoutes(backendRoutes, parentPath = '') {
  return backendRoutes
    .filter(route => {
      if (!route.path && (!route.children || route.children.length === 0) && !route.component) {
        console.warn('过滤无效路由：', route);
        return false;
      }
      if (route.path === '/' && !parentPath) {
        console.warn('根路由已在基础路由中定义，跳过动态注册');
        return false;
      }
      return true;
    })
    .map(route => {
      let routePath = route.path;
      if (!routePath) {
        routePath = parentPath ? `${parentPath}/` : '/';
      } else if (parentPath) {
        routePath = `${parentPath}/${route.path}`.replace('//', '/');
      }

      const componentName = route.component || 'default';
      const component = componentMap[componentName] || componentMap['default'];
      if (!component) {
        console.warn(`组件${componentName}不存在，使用默认组件`);
        return null;
      }

      const convertedChildren = route.children 
        ? convertRoutes(route.children, routePath) 
        : [];

      return {
        path: routePath,
        name: route.title || componentName,
        component,
        children: convertedChildren.filter(Boolean),
        meta: { title: route.title, icon: route.icon }
      };
    })
    .filter(Boolean);
}

// 3. 加载并注册动态路由
async function loadDynamicRoutes(userId) {
  try {
    if (!userId) {
      console.error('用户ID不存在，无法加载动态路由');
      return;
    }

    const res = await axios.get(
      'https://www.zhongyanzhiye.com/backApi/menu/getMenuList',
      { params: { userId } }
    );
    const backendRoutes = res.data.data;
  
    const flattenedRoutes = flattenRoutes(backendRoutes);
  
    const dynamicRoutes = convertRoutes(flattenedRoutes);

    
    dynamicRoutes.forEach(route => {
      router.addRoute(route);
    });
   

    router.addRoute({
      path: '*',
      redirect: '/'
    });
  } catch (error) {
    console.error('动态路由加载失败：', error);
    if (error.response?.status === 401) {
      store.dispatch('logout');
      localStorage.removeItem('userId');
      router.push('/');
    }
  }
}

// 4. 强化刷新时的状态恢复和路由加载
function initRouteListener() {
  let isRoutesLoaded = false;

  // 从localStorage恢复Vuex状态（解决刷新后状态丢失）
  function restoreStateFromLocal() {
    const storedUserId = localStorage.getItem('userId');
    if (storedUserId) {
      store.dispatch('login', storedUserId); // 同步到Vuex
    }
  }

  // 初始化时执行状态恢复
  restoreStateFromLocal();

  // 监听登录状态变化
  store.watch(
    () => store.getters.isAuthenticated,
    (isAuthenticated) => {
      // 双重保险获取userId
      const userId = store.state.userId || localStorage.getItem('userId');
      console.log('登录状态变化：', isAuthenticated, '用户ID：', userId);

      if (isAuthenticated && !isRoutesLoaded && userId) {
        loadDynamicRoutes(userId);
        isRoutesLoaded = true;
      } else if (!isAuthenticated) {
        router.matcher = new VueRouter({ base: process.env.BASE_URL, routes: baseRoutes }).matcher;
        isRoutesLoaded = false;
        if (router.currentRoute.path !== '/') {
          router.push('/');
        }
      }
    },
    { immediate: true }
  );
}

initRouteListener();

export default router